<app-loader></app-loader>
<h2 mat-dialog-title>Upload</h2>
<mat-dialog-content class="mat-typography">
    <mat-card>
        <mat-card-content>
            <div *ngIf="data.type == 'file'">
                <div class="container">
                    <input multiple type="file" (change)="selectFile($event)" />
                    <mat-icon>upload_file</mat-icon>
                    <p type="file">Browse from Computer</p>
                </div>
                <div>
                    <div *ngFor="let file of fileList let i=index" class="files-list">
                        <span>
                            {{file.name}}
                        </span>
                        <span>
                            <mat-icon (click)="delete(i)">delete</mat-icon>
                        </span>
                    </div>
                </div>
            </div>
            <div *ngIf="data.type == 'folder'">
                <div class="container">
                    <input type="file" (change)="selectFolder($event)" webkitdirectory mozdirectory directory />
                    <mat-icon>upload_file</mat-icon>
                    <p type="file">Browse from Computer</p>
                </div>
                <div class="files-list">
                    <span>
                        {{folderName}}
                    </span>
                </div>
            </div>
        </mat-card-content>
    </mat-card>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-raised-button (click)="uploadFile()" class="button-style">Upload</button>
    <button mat-raised-button mat-dialog-close [mat-dialog-close]="success" class="button-style">Close</button>
</mat-dialog-actions>